import { List } from 'immutable';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';

const messages = {
    requiredFields: LanguageUtils.createMessage('Cancellation rule set customer is required')
};

export default class CustomerSelectionValidation {
    static validateSelectedCancellationRuleSet(customerCancellationRuleSetId: number | undefined): boolean {
        return customerCancellationRuleSetId !== null && customerCancellationRuleSetId !== undefined && customerCancellationRuleSetId > 0;
    }

    static validateCustomerCancellationRuleSetForm(customerCancellationRuleSetId: number | undefined): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const requiredFields = CustomerSelectionValidation.validateSelectedCancellationRuleSet(customerCancellationRuleSetId);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }
}